import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

<template>
  <div class="flex flex-col gap-4" data-test-entity-list {{mergeClasses}} ...attributes>
    {{#each @items as |item|}}
      {{yield item}}
    {{else}}
      {{yield to="empty"}}
    {{/each}}
  </div>
</template>
